import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { usePageTitle } from "@/hooks/use-page-title"
import { requestTokenFromParent } from "@/lib/app-messaging"
import { REPORT_CONFIGS } from "@/types/report"
import { cn } from "@/lib/utils"
import { BarChart3, ChevronLeft } from "lucide-react"

export default function ReportLayout() {
  usePageTitle("Reports Hub")
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (typeof window !== "undefined") {
      const timer = setTimeout(() => requestTokenFromParent(), 100)
      return () => clearTimeout(timer)
    }
  }, [])

  return (
    <div className="flex flex-col h-screen bg-slate-100">
      {/* Dark header */}
      <header className="bg-slate-800 text-white">
        <div className="flex items-center gap-3 px-6 py-4">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-1 text-slate-400 hover:text-white transition-colors text-sm"
          >
            <ChevronLeft className="w-4 h-4" />
            Back
          </button>
          <div className="w-px h-5 bg-slate-600" />
          <div className="flex items-center justify-center w-8 h-8 rounded bg-slate-700">
            <BarChart3 className="w-5 h-5" />
          </div>
          <h1 className="text-lg font-semibold">Engagement Reports</h1>
        </div>

        {/* Tabs inside dark header */}
        <div className="px-6 pb-0">
          <nav className="flex gap-6" role="tablist">
            {REPORT_CONFIGS.map((report) => {
              const isActive = location.pathname === report.path
              return (
                <button
                  key={report.code}
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => report.enabled && navigate(report.path)}
                  disabled={!report.enabled}
                  className={cn(
                    "rounded-none border-b-2 px-1 pb-3 pt-0 font-medium text-sm transition-colors",
                    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/30",
                    isActive
                      ? "border-white text-white"
                      : "border-transparent text-slate-400 hover:text-slate-200",
                    !report.enabled && "cursor-not-allowed"
                  )}
                >
                  {report.label}
                  {!report.enabled && (
                    <span className="text-slate-500 ml-1 text-xs">SOON</span>
                  )}
                </button>
              )
            })}
          </nav>
        </div>
      </header>

      {/* Content */}
      <div className="flex-1 overflow-hidden">
        <Outlet />
      </div>
    </div>
  )
}
